import { axiosClient } from "../axios";

export function getInstitutesList() {
  return axiosClient.get("institutes");
}
